/**
 * @generated SignedSource<<c5ed8e869d254144241c354580150c4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DraftQuoteInput = {
  activeABTests?: ReadonlyArray<ABTestVariantInput> | null;
  contactSubmittedAt?: any | null;
  finalQuoteId?: string | null;
  gclid?: string | null;
  language?: string | null;
  lastStep?: string | null;
  lastStepAt?: any | null;
  leadOrigin?: string | null;
  leadOriginFirst?: string | null;
  leadOriginHistory?: any | null;
  leadOriginLast?: string | null;
  procedureDescription?: string | null;
  selectedLocation?: string | null;
  selectedProcedureTypes?: ReadonlyArray<string> | null;
  selectedProceduresV2?: ReadonlyArray<string> | null;
  selectedSurgeon?: string | null;
  startedAt?: any | null;
  trackingIds?: any | null;
};
export type ABTestVariantInput = {
  testId: string;
  testName?: string | null;
  variant: string;
  weight?: number | null;
};
export type QuoteProviderStartDraftQuoteMutation$variables = {
  input: DraftQuoteInput;
};
export type QuoteProviderStartDraftQuoteMutation$data = {
  readonly startDraftQuote: {
    readonly id: string;
  };
};
export type QuoteProviderStartDraftQuoteMutation = {
  response: QuoteProviderStartDraftQuoteMutation$data;
  variables: QuoteProviderStartDraftQuoteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DraftQuote",
    "kind": "LinkedField",
    "name": "startDraftQuote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuoteProviderStartDraftQuoteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuoteProviderStartDraftQuoteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aa9ef3c56e6c023cb45324932f533910",
    "id": null,
    "metadata": {},
    "name": "QuoteProviderStartDraftQuoteMutation",
    "operationKind": "mutation",
    "text": "mutation QuoteProviderStartDraftQuoteMutation(\n  $input: DraftQuoteInput!\n) {\n  startDraftQuote(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ed1c188eb5f3f0ca3841c7f1c04abef0";

export default node;
